import React from 'react';
export function AboutSection() {
  return <section id="about" className="w-full bg-white py-16 md:py-24" data-id="element-7">
      <div className="container mx-auto px-4" data-id="element-8">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-9">
          <div className="w-full md:w-1/2" data-id="element-10">
            <div className="relative" data-id="element-11">
              <div className="bg-blue-700 absolute -top-6 -left-6 w-64 h-64 rounded-lg opacity-10" data-id="element-12"></div>
              <div className="bg-blue-900 absolute -bottom-6 -right-6 w-64 h-64 rounded-lg opacity-10" data-id="element-13"></div>
              <div className="relative bg-gradient-to-br from-blue-800 to-blue-900 w-full aspect-video rounded-lg overflow-hidden flex items-center justify-center" data-id="element-14">
                <div className="text-center text-white p-8" data-id="element-15">
                  <h3 className="text-3xl font-bold mb-4" data-id="element-16">量盛科技</h3>
                  <p className="text-blue-100" data-id="element-17">专注金融科技 · 引领量化交易</p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-18">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-19">
              关于我们
            </h2>
            <p className="text-lg text-gray-700 mb-6" data-id="element-20">
              量盛科技是一家专注于金融科技领域的创新型企业，致力于为机构和个人投资者提供专业的量化交易解决方案。我们拥有一支由金融专家、数学家和计算机科学家组成的精英团队。
            </p>
            <p className="text-lg text-gray-700 mb-8" data-id="element-21">
              凭借深厚的行业经验和技术实力，我们开发了一系列高效、稳定的量化交易策略和系统，帮助客户在复杂多变的金融市场中获取稳定收益。
            </p>
            <div className="grid grid-cols-2 gap-6" data-id="element-22">
              <div data-id="element-23">
                <h4 className="text-2xl font-bold text-blue-700 mb-2" data-id="element-24">5+</h4>
                <p className="text-gray-600" data-id="element-25">年行业经验</p>
              </div>
              <div data-id="element-26">
                <h4 className="text-2xl font-bold text-blue-700 mb-2" data-id="element-27">100+</h4>
                <p className="text-gray-600" data-id="element-28">成功策略</p>
              </div>
              <div data-id="element-29">
                <h4 className="text-2xl font-bold text-blue-700 mb-2" data-id="element-30">30+</h4>
                <p className="text-gray-600" data-id="element-31">专业团队</p>
              </div>
              <div data-id="element-32">
                <h4 className="text-2xl font-bold text-blue-700 mb-2" data-id="element-33">99.9%</h4>
                <p className="text-gray-600" data-id="element-34">系统稳定性</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}